export default __webpack_public_path__ + "static/media/Boots of the Spheres.0d22bb47.jpg";